import { useState, useCallback } from 'react'
import { authenticatedFetchJson } from '../services/api/apiClient'
import { apiEndpoints } from '../consts'

const useUsageOverviewData = () => {
  const [campaigns, setCampaigns] = useState([])
  const [summary, setSummary] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchUsageOverview = useCallback(async (month, year) => {
    try {
      setLoading(true)
      setError(null)

      const params = new URLSearchParams()
      if (month) params.append('month', month)
      if (year) params.append('year', year)

      const queryString = params.toString()
      const url = `${apiEndpoints.campaignsUsageOverview}${queryString ? `?${queryString}` : ''}`

      const data = await authenticatedFetchJson(url)
      setCampaigns(data.data || [])
      setSummary(data.meta || null)
    } catch (err) {
      setError(err.message || 'Failed to load usage overview')
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    campaigns,
    summary,
    loading,
    error,
    fetchUsageOverview
  }
}

export default useUsageOverviewData
